const defaultRender = (value) =>
  value === 0 || value ? value : "--";

const columns = [
  {
    title: "User",
    dataIndex: "user",
  },
  {
    title: "A/C No.",
    dataIndex: "login",
    render: defaultRender,
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
    render: defaultRender,
  },
  {
    title: "Type",
    dataIndex: "type",
    render: defaultRender,
  },
  {
    title: "Volume",
    dataIndex: "volume",
    render: defaultRender,
  },
  {
    title: "Open Price",
    dataIndex: "priceOpen",
    render: defaultRender,
  },
  {
    title: "Current Price",
    dataIndex: "priceCurrent",
    render: defaultRender,
  },
  {
    title: "Stop Loss",
    dataIndex: "stopLoss",
    render: defaultRender,
  },
  {
    title: "Take Profit",
    dataIndex: "takeProfit",
    render: defaultRender,
  },
  {
    title: "Swap",
    dataIndex: "swap",
    render: defaultRender,
  },
  {
    title: "Profit",
    dataIndex: "profit",
    render: defaultRender,
  },
  {
    title: "Position ID",
    dataIndex: "positionId",
    render: defaultRender,
  },
  {
    title: "Time",
    dataIndex: "time",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "tradeStatus",
    render: defaultRender,
  },
];

export default columns;
